// import fetch from 'cross-fetch'
import { checkStatus, parseJSON } from "./responseHandler";
import axios from "axios";
import { SessionHelper } from "./session";
// Make an api call
export default async (baseUrl, url, method = "post", body, headers) => {
  let allHeaders= Object.assign({},SessionHelper.getHeader(),headers);
  // console.log('%c ye hai apilcaller: ','font-size:40px;',allHeaders);
  // console.log("%c body : ","font-size:30px",body);
  return axios(`${baseUrl}${url}`, {
    method,
    data: JSON.stringify(body),
    headers:allHeaders
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(error => {
      throw error;
    });
};
